export const MessageType = Object.freeze({
    ORIGINAL: 'original',
    REPLY: 'reply',
    COPY: 'copy',
    FORWARD: 'forward',
});
